import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=1a5c734c"
import script from "./submission.vue?vue&type=script&lang=ts"
export * from "./submission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports